<div class="input">
  <input type="number" [id]="field.name" (keydown)="onKeyDown($event)" />
</div>
<div class="values">
  <div class="item" *ngFor="let val of value">
    <div class="name">{{val}}</div>
    <button type="button" class="remove" (click)="removeValue(val)"></button>
  </div>
</div>
